import React, { useRef, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { motion, useAnimation, useInView } from 'framer-motion';
import image1 from './../../assets/images/images-1.png';
import image2 from './../../assets/images/images-2.png';
import image3 from './../../assets/images/takii-1.jpg';
import image4 from './../../assets/images/telechargement.jpg';
import './NosClient.css';

const NosClient = () => {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, margin: "-100px" });

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [controls, isInView]);

  const clients = [
    { id: 1, image: image1 },
    { id: 2, image: image2 },
    { id: 3, image: image3 },
    { id: 4, image: image4 },
  ];

  return (
    <div className='container clients-container' ref={ref}>
      <motion.div
        className='section-header'
        initial={{ opacity: 0, y: -20 }}
        animate={controls}
        variants={{
          visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
          hidden: { opacity: 0, y: -20 }
        }}
      >
        <span className="clients-eyebrow">Ils nous font confiance</span>
        <h2 className='clients-title'>
          Nos Clients
          <motion.span
            className="title-decoration"
            initial={{ width: 0 }}
            animate={controls}
            variants={{
              visible: { width: "100%", transition: { delay: 0.3, duration: 0.8 } },
              hidden: { width: 0 }
            }}
          />
        </h2>
      </motion.div>

      <div className='clients-grid'>
        {clients.map((client, index) => (
          <motion.div
            key={client.id}
            className='client-card'
            initial={{ opacity: 0, y: 16 }}
            animate={controls}
            variants={{
              visible: {
                opacity: 1,
                y: 0,
                transition: {
                  delay: 0.15 + index * 0.08,
                  duration: 0.5
                }
              },
              hidden: { opacity: 0, y: 16 }
            }}
          >
            <Image
              src={client.image}
              alt="Client Home Deco"
              className='client-logo'
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default NosClient;
